'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobUserPermissions', cobUserPermissions);

	cobUserPermissions.$inject = ['sessionService'];

	function cobUserPermissions(_sessionService_) {
		var sessionService = _sessionService_;

		return {
			restrict: 'A',

			scope: {
				requiredPermission: '@requiredPermission',
				disableUnauthorized: '@disableUnauthorized'
			},

			link: function(scope, element) {
				function applyPermission() {
					var disableUnauthorized = false;
					if (scope.disableUnauthorized) {
						disableUnauthorized = (scope.disableUnauthorized.toLowerCase() == true);
					}

					if (!hasPermission()) {
						if (disableUnauthorized) {
							element.attr('disabled', 'disabled');
						} else {
							element.hide();
						}
					}
				}

				function hasPermission() {
					if (scope.requiredPermission) //  requires a permission
					{
						switch (scope.requiredPermission.toLowerCase()) {
						case 'read':
							return sessionService.isAuthorizedBrokerRead();
						case 'write':
							return sessionService.isAuthorizedBrokerWrite();
						case 'admin':
							return sessionService.isAuthorizedBrokerAdmin();
						default:
							// unknown permission
							return false;
						}
					} else // no permissions are required
					{
						return true;
					}
				}

				applyPermission();
			}
		};
	}
})();
